(function() {
    'use strict';
    angular
        .module('emarket.main.post')
        .controller('PostDetailController', ['$log', '$window', '$sce', '$state', '$rootScope', 'SellerFactory', 'ChatDialog', '$mdMedia', '$mdDialog', '$scope', '$location', '$mdBottomSheet', '$stateParams', 'Socialshare', 'ShareSheet', 'Post', 'Favorite', 'Profile', 'Utils', 'ImageTransformer', 'Auth', 'Offer', 'Category', 'CustomField', 'Seo', 'post', function($log,
            $window,
            $sce,
            $state,
            $rootScope,
            SellerFactory,
            ChatDialog,
            $mdMedia,
            $mdDialog,
            $scope,
            $location,
            $mdBottomSheet,
            $stateParams,
            Socialshare,
            ShareSheet,
            Post,
            Favorite,
            Profile,
            Utils,
            ImageTransformer,
            Auth,
            Offer,
            Category,
            CustomField,
            Seo,
            post) {
            var vm = this;
            var user = Auth.getUser();
            var Seller = SellerFactory.create($scope);
            vm.isMobile = $mdMedia('xs') || $mdMedia('sm');
            vm.socialshareUrl = $window.location.href;
            //TODO: get the post id from the resolve

            vm.post = post;
            console.log(post.owner);
            vm.post.content = $sce.trustAsHtml(post.content);
            if (vm.post.custom) {
                var customFields = Object.keys(vm.post.custom).reduce(function(acc, key) {
                    acc[key] = vm.post.custom[key].value;
                    return acc;
                }, {});
                CustomField.get(post.categoryTree[0]._id, customFields).then(function(fields) {
                    if (fields.length > 0) {
                        vm.fields = [];
                        fields.forEach(function(field) {
                            if (vm.post.custom[field.slug]) {
                                field.value = vm.post.custom[field.slug].value;
                                vm.fields.push(field);
                            }
                        });
                    }
                });
            }
            vm.isMy = user ? user._id === post.owner._id : false;
            vm.showNavBar = $stateParams.showNavBar;
            if (user) {
                Favorite.$search({
                    postId: post._id,
                    seller: post.owner ? post.owner._id || post.owner : ''
                }).$then(function(favorites) {
                    favorites.forEach(function(favorite) {
                        if (favorite.type === 'seller') {
                            vm.favoriteSeller = favorite;
                        }
                        if (favorite.type === 'post') {
                            vm.favoritePost = favorite;
                        }
                    });
                });
            }
            vm.reportPost = function() {
                Post.report(post);
            };
            vm.showSellerCard = function() {
                Profile.showCard({
                    _id: vm.post.owner
                });
            };

            var removeFavorite = function(type) {
                if (type === 'seller') {
                    vm.favoriteSeller.$destroy();
                    vm.favoriteSeller = null;
                }
                if (type === 'post') {
                    vm.favoritePost.$destroy();
                    vm.favoritePost = null;
                }
            };

            vm.handleFavoriteSeller = function() {
                if (vm.favoriteSeller) {
                    removeFavorite('seller');
                } else {
                    var params = {
                        seller: vm.post.owner ? vm.post.owner._id || vm.post.owner : '',
                        type: 'seller'
                    };
                    vm.favoriteSeller = Favorite.$create(params);
                }
            };

            vm.handleFavoritePost = function() {
                if (vm.favoritePost) {
                    removeFavorite('post');
                } else {
                    var params = {
                        postId: vm.post._id,
                        type: 'post'
                    };
                    vm.favoritePost = Favorite.$create(params);
                }
            };

            vm.showSellerContact = function($ev) {
                var fullScreen = false;
                if ($state.current.name === 'main.post.detail') {
                    fullScreen = true;
                }
                Seller.showContact($ev, vm.post.owner, fullScreen);
            };
            vm.showShareSheet = function() {
                ShareSheet.show(vm.post);
            };

            function loadRelatedProducts() {
                var owner = post.owner._id || post.owner;
                return Profile.getRelatedProducts(owner, post._id, 5).then(function(post) {
                    if (post.length > 0) {
                        return post;
                    }
                });
            }
            vm.relatedPromise = loadRelatedProducts();
            vm.relatedPromise.then(function(posts) {
                vm.relatedProducts = posts;
            });
            // vm.relatedProducts = loadRelatedProducts();

            var sharePost = function(provider, attrs) {
                attrs = attrs = {};
                attrs.socialshareDisplay = 'iframe';
                attrs.socialshareTitle = vm.post.title;
                attrs.socialshareUrl = $window.location.href;
                if (vm.post.images.length > 0) {
                    var image = ImageTransformer.get(vm.post.images[0].path, ImageTransformer.LARGE);
                    attrs.socialshareMedia = image;
                    //TODO: mission currency
                    attrs.socialshareDescription = vm.post.title + ' ' + vm.post.prices.list;
                    //TODO: add the post link
                    attrs.socialshareBody =
            'Hola, te comparto este producto que vi en eMarket ' + vm.post.title;
                }
                // attrs.socialshareMedia = window.location.href;
                // attrs.socialshareMedia = Utils.getUrl() + '/' + vm.post.images.paths;
                //TODO get the media and the url
                attrs.socialshareText = vm.post.title;
                attrs.socialshareSubject = vm.post.title;
                Socialshare.share({
                    provider: provider,
                    attrs: attrs
                });
            };
            vm.fbShare = function() {
                sharePost('facebook', {
                    socialshareType: 'share',
                    socialshareVia: '392697910777737'
                });
            };
            vm.twShare = function() {
                sharePost('twitter');
            };
            vm.gpShare = function() {
                sharePost('google');
            };
            vm.whatsappShare = function() {
                sharePost('whatsapp');
            };

            // vm.emailShare = function() {
            //     sharePost('email', {
            //         socialshareSubject: 'Titulazo del anuncio',
            //         socialshareBody: 'hola, te comparto este xxxx que encontre, cuesta ${price} miralo en'
            //     });
            // };

            vm.showOfferDialog = function() {
                Offer.showDialog(vm.post, vm.post.offers).then(function() {
                    // FIXME: Not load the post again, just return the offerst from showDialog
                    Post.$find(post._id)
                        .$asPromise()
                        .then(function(response) {
                            vm.post.offers = response.offers;
                        });
                });
            };
        }]);
}());
